import {
  getSnapshot,
  setSessionExpired,
} from '@configs/axios/session-expired-store/sessionExpiredStore';
import { resetHeapIdentity } from '@configs/heap/heapAnalytics';
import { queryClient } from '@configs/queryClient';
import {
  getCurrentAuthType,
  getMsalInstance,
} from '@shared/helpers/msal-instance/msalInstance';

import { getLoginHint } from './handleSessionExpired.utils';

let pendingExpiry: Promise<void> | null = null;

async function expireSession(): Promise<void> {
  if (getSnapshot()) {
    return;
  }

  const msal = await getMsalInstance();
  const account = msal.getActiveAccount() ?? msal.getAllAccounts()[0];

  // No cached credentials means the user never signed in on this browser, not that a session expired.
  if (!account) {
    return;
  }

  // The MSAL cache is kept on purpose: it is cleared right before re-login so a refresh still shows this screen.
  setSessionExpired({
    authType: getCurrentAuthType(),
    loginHint: getLoginHint(account),
  });
  resetHeapIdentity();
  queryClient.clear();
}

/**
 * Switches the app to the inline session-expired screen and drops cached server data.
 * Concurrent callers share one run.
 */
export function handleSessionExpired(): Promise<void> {
  pendingExpiry ??= expireSession().finally(() => {
    pendingExpiry = null;
  });
  return pendingExpiry;
}
